module.exports = __webpack_public_path__ + "media/newstyle/images/icon_linkedin-e0be2716882c881bd52c9b408b240766.svg";